const contactsSection = $('#contacts-hero');
const contactsBg = contactsSection.find('.contacts-hero-bg');

let contactsInTL = gsap.timeline({
  paused: true,
  onComplete: () => {
    $(window).trigger('heroReady');
    contactsSection.css('overflow-x', 'unset');
    lenis.start();
    animateFormSwitch(contactsSection);
  },
});

const setContacts = () => {
  contactsSection.css('overflow-x', 'hidden');
  
  gsap.set(contactsBg, {
    top: '100vh',
    left: '50vw',
    width: 0,
    height: 0,
  });
};

const contactsInAnimation = () => {
  const gradientConfig = {
    gradient: 'linear-gradient(127deg, #081B48 0%, #8AD1DA 50%, #081B48 100%);',
    start: 120,
    end: 0,
  };

  const contactSwitcher = contactsSection.find('.switch');
  const formPlacer = contactsSection.find('.big-form-placer').eq(0);
  const heroTitle = contactsSection.find('.contact-section-title');

  contactsInTL.addLabel('step1');
  contactsInTL.add(
    gsap.to(contactsBg, {
      top: '91.359vh',
      left: '47.2vw',
      width: '5.6vw',
      height: '5.6vh',
      duration: 0.4,
      ease: 'pageInEasing',
    }),
    0.1
  );
  contactsInTL.add(
    gsap.to(contactsBg, {
      top: '0vw',
      left: '0vw',
      width: '100vw',
      height: '100vh',
      duration: 1.1,
      ease: 'pageInEasing',
      onComplete: () => {
        $('.gradient-background').css('display', 'block');
        contactsBg.css('height', '100%');
      },
    }),
    0.5
  );
  if (isDesktop()) {
    const animationConfig = {
      offsetPercent: '150',
      opacityStart: 0,
      blurStart: '20px',
      duration: 1,
      delay: 0.3,
      stagger: 0.15,
      isDurationCommon: true,
    }
    contactsInTL.add(addTitleAnimation({element: heroTitle, animationConfig: animationConfig}).play(), 0.85)
  }

  contactsInTL.add(elementInAnimationYWOpacity(contactSwitcher, '100%', 0, 1, 0.833, 0.633, 0.2).play(), 1.1);
  contactsInTL.add(animateFormIn(formPlacer, {formPlacer: 0.7, formOverflows: 1}).play(), 1.5);
  contactsInTL.add(() => animateFormLines(contactsSection, 0), 1.5);
  contactsInTL.add(headerAnimation(true, 0.6, 0.01).play(), 2.2);
};

contactsInAnimation();
setContacts();
$(window).on('load', function () {
  const [nav] = performance.getEntriesByType('navigation');
  $(window).trigger('heroReady');

  if (nav.type == 'navigate') {
    $('.gradient-background').css('display', 'none');
    lenis.stop();
    headerAnimation(false, 0, 0).play();
    contactsInTL.play();
  } else {
    contactsInTL.progress(1);
  }
  gsap.set($('body'), { opacity: 1 });
});
